var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 39,
    viewBox: "0 0 111 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38562 0C-0.817846 1.61168 -0.488655 7.38686 0.576373 10.073L6.38562 33.3848C8.47694 38.9105 11.7108 39.3326 13.0663 38.853H98.1717C103.981 38.853 105.24 35.2075 105.143 33.3848L110.081 10.073C113.334 2.24484 107.176 0.0959333 103.69 0H6.38562Z",
    fill: "url(#paint0_linear_458_15)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_15",
    x1: 29,
    y1: -0.00000183529,
    x2: 78,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B22D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC2BA0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector-6.a2fc0a2d1375f65516e07af9a971ca80.svg";
export { ForwardRef as ReactComponent };